import { render, staticRenderFns } from "./MypageBlockedUserListSection.vue?vue&type=template&id=63ae4b34&scoped=true"
import script from "./MypageBlockedUserListSection.vue?vue&type=script&lang=ts"
export * from "./MypageBlockedUserListSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageBlockedUserListSection.vue?vue&type=style&index=0&id=63ae4b34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae4b34",
  null
  
)

export default component.exports